import classes from "./Marketing.module.css";
import hvac1 from "../../images/hvac1.avif";
import hvac2 from "../../images/hvac2.avif";

export default function Marketing() {
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.photo}>
          <img src={hvac1} alt="marketing" />
        </div>
        <p className={classes.title}>Efficient Cooling, Maximum Comfort</p>
        <p className={classes.subtitle}>
          Experience the Power of Advanced HVAC Solutions
        </p>
        <p className={classes.message}>
          Stay cool and comfortable with our energy-efficient HVAC systems.
          Designed for superior performance, low energy consumption, and
          long-lasting durability—perfect for homes and businesses worldwide.
        </p>
      </div>
      <div className={classes.content}>
        <div className={classes.photo}>
          <img src={hvac2} alt="marketing" />
        </div>
        <p className={classes.title}>Breathe Easy with Smart Climate Control</p>
        <p className={classes.subtitle}>
          Innovative HVAC Technology for Every Space
        </p>
        <p className={classes.message}>
          Enhance your indoor air quality with our cutting-edge HVAC products.
          Enjoy precise temperature control, quiet operation, and eco-friendly
          technology—all shipped directly from China to your doorstep.
        </p>
      </div>
    </div>
  );
}
